import { AppScope } from "../types";

export const ENV = process.env.NODE_ENV || "development";
export const APP_SCOPE = (process.env.REACT_APP_SCOPE || "swap") as AppScope;

export const STORAGE_ITEMS = ["slippagePercent", "cluster", "terms"] as const;
export const PARAMS_ITEMS = ["cluster"] as const;
